module.exports = __webpack_public_path__ + "img/474643_696F7D_A9ABB8_8B8C93-256px.97ad6466.png";